module.exports = __webpack_public_path__ + "media/04.a42ac317.mp4";